import React from 'react';
import { Placeholder } from '@components/common/Placeholder';

export const NotFound: React.FC = () => {
  return (
    <Placeholder 
      title="404 - Page Not Found" 
      description="The page you are looking for does not exist."
    />
  );
};